import { apiSlice } from './apiSlice';
import type { FinanceUserBrief } from './financeApi';

export interface CompanyDriver {
  id: number;
  fullName: string;
  phone?: string;
  defaultVehicle: {
    id: number;
    registrationNumber: string;
    vehicleCategory?: string;
    vehicleType?: string;
    brand?: string;
  } | null;
  defaultTrailerVehicle: {
    id: number;
    registrationNumber: string;
    vehicleCategory?: string;
    vehicleType?: string;
    brand?: string;
  } | null;
  status: 'in_route' | 'idle';
  currentRoute: {
    id: number;
    routeNumber: string;
    plannedLoadingDate?: string;
    plannedUnloadingDate?: string;
    actualLoadingDate?: string;
    actualUnloadingDate?: string;
    loadingAddress?: string;
    unloadingAddress?: string;
    responsibleLogist?: FinanceUserBrief | null;
  } | null;
  assignedLogist?: FinanceUserBrief | null;
  application: {
    id: number;
    internalNumber: string;
    applicationDate?: string;
    externalNumber?: string;
    client: {
      id: number;
      name: string;
    };
    responsibleLogist?: FinanceUserBrief | null;
  } | null;
  activeRoutesCount: number;
}

export interface CompanyVehicle {
  id: number;
  registrationNumber: string;
  vehicleCategory?: string;
  vehicleType?: string;
  brand?: string;
  carryingCapacity?: number;
  volumeM3?: number;
  defaultDriver: {
    id: number;
    fullName: string;
    phone?: string;
  } | null;
  status: 'in_route' | 'idle';
  currentRoute: {
    id: number;
    routeNumber: string;
    plannedLoadingDate?: string;
    plannedUnloadingDate?: string;
  } | null;
  currentDriver: {
    id: number;
    fullName: string;
    phone?: string;
  } | null;
  activeRoutesCount: number;
}

export interface DriversResponse {
  drivers: CompanyDriver[];
  total: number;
}

export interface VehiclesResponse {
  vehicles: CompanyVehicle[];
  total: number;
}

export const driversVehiclesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyDrivers: builder.query<DriversResponse, { status?: 'all' | 'in_route' | 'idle' }>({
      query: ({ status = 'all' }) => ({
        url: '/drivers-vehicles/drivers',
        params: { status }
      }),
      transformResponse: (response: any) => response.data || response,
      providesTags: ['Driver', 'Route']
    }),
    getCompanyVehicles: builder.query<VehiclesResponse, void>({
      query: () => '/drivers-vehicles/vehicles',
      transformResponse: (response: any) => response.data || response,
      providesTags: ['Vehicle', 'Route']
    })
  })
});

export const {
  useGetCompanyDriversQuery,
  useGetCompanyVehiclesQuery
} = driversVehiclesApi;
